
export default function WhyChooseUsSection() {
  const reasons = [
    {
      icon: 'ri-map-pin-line',
      title: '地域密着',
      description: '地域の特性を熟知したスタッフが、エリアの魅力や将来性を含めてご提案いたします。',
      stats: '対応エリア数',
      number: '15+'
    },
    {
      icon: 'ri-award-line',
      title: '豊富な実績',
      description: '創業以来、数多くの取引実績を積み重ね、お客様から高い評価をいただいております。',
      stats: '年間取引件数',
      number: '500+'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'アフターサポート',
      description: '取引完了後も継続的にサポート。住宅ローンや税務相談など、幅広くフォローいたします。',
      stats: '顧客満足度',
      number: '98%'
    }
  ];

  return (
    <section className="py-16 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            選ばれる理由
          </h2>
          <p className="text-lg text-gray-600">
            なぜ多くのお客様に選ばれているのか
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${reason.icon} text-3xl text-blue-600`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {reason.title}
              </h3>
              
              <p className="text-gray-600 mb-6">
                {reason.description}
              </p>
              
              <div className="border-t pt-6">
                <div className="text-3xl font-bold text-blue-600 mb-1">
                  {reason.number}
                </div>
                <div className="text-sm text-gray-500">
                  {reason.stats}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
